import axios from 'axios';

const apiV3 = axios.create({
  baseURL: `${process.env.REACT_APP_INSV_API_V3}`
});
apiV3.interceptors.request.use(async (config) => {
  const token = localStorage.tolkenINSV;

  if (token)
    config.headers.authorization = `${token}`;

  return config;
});

apiV3.interceptors.response.use(
  (response) => {
    return response;
  },
  
  (err) => Promise.reject(err)
);

export default apiV3